/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteRoleInput = {
    id: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteRoleMutationVariables = {
    input: DeleteRoleInput;
};
export type deleteRoleMutationResponse = {
    readonly deleteRole: {
        readonly deletedRoleId: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type deleteRoleMutation = {
    readonly response: deleteRoleMutationResponse;
    readonly variables: deleteRoleMutationVariables;
};



/*
mutation deleteRoleMutation(
  $input: DeleteRoleInput!
) {
  deleteRole(input: $input) {
    deletedRoleId
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteRoleInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRolePayload",
    "kind": "LinkedField",
    "name": "deleteRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedRoleId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteRoleMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRoleMutation(\n  $input: DeleteRoleInput!\n) {\n  deleteRole(input: $input) {\n    deletedRoleId\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '512aeaf8a5f2f9d8b758a578e043538e';
export default node;
